// Deterministic procedural crest: league rivals are regenerated each
// season, so crests must derive from the club name alone.

// Warm/jewel ramp — deliberately no bright sky-cyan so rival crests don't
// clash with the gold broadcast accents or read as the player's club.
const PALETTE = [
  ['#E2725B', '#3B1410'], // terracotta
  ['#4ADE80', '#14532D'], // padel green
  ['#FB923C', '#431407'], // orange
  ['#F5C542', '#422006'], // gold
  ['#A78BFA', '#2E1065'], // violet
  ['#F87171', '#450A0A'], // red
  ['#A3B14A', '#2A2F0A'], // olive
  ['#E2E8F0', '#1E293B'], // steel
] as const

const SHIELDS = [
  // classic shield
  'M12 1 L22 4 V12 C22 18 17.5 21.5 12 23 C6.5 21.5 2 18 2 12 V4 Z',
  // pointed banner
  'M3 1 H21 V16 L12 23 L3 16 Z',
  // rounded badge
  'M12 1 C18 1 22 5 22 11 C22 18 17 22 12 23 C7 22 2 18 2 11 C2 5 6 1 12 1 Z',
  // chevron shield
  'M12 1 L22 5 V13 C22 19 17 22 12 23 C7 22 2 19 2 13 V5 Z',
] as const

function hashName(name: string): number {
  let h = 0
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0
  }
  return h
}

function initials(name: string): string {
  const words = name
    .split(/\s+/)
    .filter((w) => w.length > 2 || /^[A-ZÁÉÍÓÚ]/.test(w))
  return words
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
}

export function ClubCrest({ name, size = 24 }: { name: string; size?: number }) {
  const h = hashName(name)
  const [primary, secondary] = PALETTE[h % PALETTE.length]
  const shield = SHIELDS[(h >> 3) % SHIELDS.length]
  const striped = (h >> 5) % 2 === 0

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label={`Escudo de ${name}`}
      style={{ flex: 'none' }}
    >
      <path d={shield} fill={secondary} stroke={primary} strokeWidth="1.4" />
      {striped && (
        <path d={shield} fill="none" stroke={primary} strokeWidth="2.6" strokeDasharray="2.5 4" opacity="0.45" />
      )}
      <text
        x="12"
        y="13.5"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="'Exo 2', system-ui, sans-serif"
        fontWeight="800"
        fontSize="8.5"
        fill={primary}
      >
        {initials(name)}
      </text>
    </svg>
  )
}
